import { Dialog, DialogContent, DialogTitle, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useState } from 'react';
import type { Detection } from '../../app/types';
import PageSection from '../shared/PageSection';

export default function DetectionsPage({ detections }: { detections: Detection[] }) {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [previewTitle, setPreviewTitle] = useState<string | null>(null);

  const openPreview = (url: string | undefined, title: string) => {
    if (!url) {
      return;
    }
    setPreviewUrl(url);
    setPreviewTitle(title);
  };

  const closePreview = () => {
    setPreviewUrl(null);
    setPreviewTitle(null);
  };

  return (
    <PageSection title="Detections" subtitle="Detected faces captured from uploaded snapshots.">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Created</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Camera</TableCell>
            <TableCell>Snapshot</TableCell>
            <TableCell>Thumbnail</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {detections.map((detection) => (
            <TableRow key={detection.detectedFaceId}>
              <TableCell>{new Date(detection.createdAt).toLocaleString()}</TableCell>
              <TableCell>{detection.status}</TableCell>
              <TableCell>{detection.cameraId}</TableCell>
              <TableCell>{detection.snapshotId}</TableCell>
              <TableCell>
                {detection.cropThumbnailUrl ? (
                  <img
                    src={detection.cropThumbnailUrl}
                    alt="Detection thumbnail"
                    style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 6, cursor: 'pointer' }}
                    onClick={() =>
                      openPreview(detection.cropUrl ?? detection.cropThumbnailUrl, 'Detection crop')
                    }
                  />
                ) : (
                  detection.cropObjectKey ?? 'Pending crop'
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Dialog open={Boolean(previewUrl)} onClose={closePreview} maxWidth="md" fullWidth>
        <DialogTitle>{previewTitle ?? 'Detection crop'}</DialogTitle>
        <DialogContent>
          {previewUrl ? (
            <img src={previewUrl} alt="Detection crop" style={{ width: '100%', height: 'auto', borderRadius: 8 }} />
          ) : (
            <Typography color="text.secondary">Preview unavailable.</Typography>
          )}
        </DialogContent>
      </Dialog>
    </PageSection>
  );
}
